import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
import {
  DirectionsCarFilled,
  Person,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import logo from "../Components/img/cadrideLogo.jpeg";

function LoginType() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        p: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "100%",
          maxWidth: 500,
          p: 5,
          borderRadius: 4,
          textAlign: "center",
          backdropFilter: "blur(10px)",
        }}
      >
        <Box mb={3}>
          <img
            src={logo}
            alt="Logo"
            style={{
              width: 90,
              height: 90,
              objectFit: "contain",
            }}
          />
        </Box>

        <Typography
          variant="h4"
          fontWeight={700}
          gutterBottom
        >
          Welcome
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          mb={4}
        >
          Choose how you would like to continue
        </Typography>

        <Stack spacing={2}>
          <Button
            fullWidth
            size="large"
            startIcon={<DirectionsCarFilled />}
            onClick={() => navigate("/rider")}
            sx={{
              py: 1.8,
              borderRadius: 3,
              fontWeight: 600,
              background:
                "linear-gradient(90deg,#7c3aed,#9333ea)",
              color: "#fff",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 6,
              },
            }}
          >
            Driver Login
          </Button>

          <Button
            fullWidth
            size="large"
            startIcon={<Person />}
            onClick={() => navigate("/signin")}
            sx={{
              py: 1.8,
              borderRadius: 3,
              fontWeight: 600,
              background:
                "linear-gradient(90deg,#2563eb,#3b82f6)",
              color: "#fff",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 6,
              },
            }}
          >
            Passenger Login
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}

export default LoginType;